// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__oqI9I","productName":"Table_productName__1iZBc"};